"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _PopoverBase = _interopRequireDefault(require("./PopoverBase"));
var _Text = _interopRequireDefault(require("../Typography/Text"));
var _excluded = ["children", "tooltipText", "disabled", "width", "w", "automationHook"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /**  Text for the tooltip. Will automatically determine the tooltip to render the text in a Tooltip Label */
  tooltipText: _propTypes["default"].string,
  /** children that will be wrapped by the tooltip */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  /** Tooltip container props ******** */
  /**
   * Disabled: will change the cursor and hide the tooltip
   */
  disabled: _propTypes["default"].bool,
  /* Deprecated prop, `w` should be used */
  width: _propTypes["default"].string,
  /* An optional width for the Tooltip. Needs to be a valid css value */
  w: _propTypes["default"].string,
  /**
   * Data attribute used for automation testing
   * Will append the `_tooltip-text` suffix
   */
  automationHook: _propTypes["default"].string
};
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Tooltip__Wrapper",
  componentId: "sc-14su498-0"
})([""]);
Wrapper.displayName = "TooltipWrapper";
var Label = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "Tooltip__Label",
  componentId: "sc-14su498-1"
})(["color:", ";background-color:", ";font-size:", ";padding:", " ", ";border-radius:", ";", " ", ""], function (props) {
  return props.theme.colors.textInverted;
}, function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.fontSizes.xs;
}, function (props) {
  return props.theme.spaces.xxs;
}, function (props) {
  return props.theme.spaces.xs;
}, function (props) {
  return props.theme.borderRadius.xs;
}, function (props) {
  return props.width && (0, _styledComponents.css)(["width:", ";"], props.width);
}, function (props) {
  return props.w && (0, _styledComponents.css)(["width:", ";"], props.w);
});
Label.displayName = "TooltipLabel";
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    tooltipText = _ref.tooltipText,
    disabled = _ref.disabled,
    width = _ref.width,
    w = _ref.w,
    automationHook = _ref.automationHook,
    other = _objectWithoutProperties(_ref, _excluded);
  return disabled || !tooltipText ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children) : /*#__PURE__*/_react["default"].createElement(_PopoverBase["default"], _extends({
    automationHook: automationHook,
    renderTrigger: function renderTrigger(_ref2) {
      var openPopover = _ref2.openPopover,
        closePopover = _ref2.closePopover;
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        onMouseEnter: openPopover,
        onMouseLeave: closePopover
      }, children);
    },
    positions: ["top", "bottom", "left", "right"],
    align: "center",
    gap: "xxs"
  }, other), function () {
    return /*#__PURE__*/_react["default"].createElement(Label, _extends({
      withNewLines: true,
      width: width,
      w: w
    }, (0, _automationHooks.hook)(automationHook, "tooltip-text")), tooltipText);
  });
};
Tooltip.propTypes = propTypes;
Tooltip.displayName = "Tooltip";
var _default = Tooltip;
exports["default"] = _default;